<template>
  <div class="app-container">
    <h1>作业汇总</h1>
    <!-- 添加科目筛选 -->
    <div class="filter-container" style="margin-bottom: 20px;">
      <el-select v-model="selectedSubject" placeholder="请选择科目" clearable @change="handleSubjectChange" style="width: 200px;">
        <el-option
          v-for="item in subjectOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>

    <!-- <el-button type="primary" @click="test">测试批改结果表</el-button>
    <el-button type="primary" @click="testdownload">测试组卷按钮</el-button>
    <el-button type="primary" @click="test1">测试获取图片按钮</el-button> -->

    <!-- 无数据时的默认显示 -->
    <el-card v-if="showNoDataMessage" class="empty-homework-card">
      <div slot="header" class="homework-header">
        <span><i class="el-icon-document"></i> 作业汇总</span>
      </div>
      <div class="empty-content">
        <div class="empty-icon">
          <i class="el-icon-warning"></i>
        </div>
        <div class="empty-text">
          <h3>{{ noDataMessage }}</h3>
          <p>请先选择课程后再查看作业</p>
        </div>
        <div class="empty-actions">
          <el-button type="primary" size="large" @click="goToCourseSelection">
            <i class="el-icon-edit"></i> 去选课
          </el-button>
        </div>
      </div>
    </el-card>

    <!-- 添加标签页 -->
    <el-tabs v-model="activeTab" type="border-card" style="margin-top: 20px;" v-if="!showNoDataMessage">
      <el-tab-pane label="未提交作业" name="unsubmitted">
        <el-table
          v-loading="loading"
          :data="unsubmittedHomework"
          border
          style="width: 100%"
          empty-text="暂无未提交的作业">
          <el-table-column prop="id" label="ID" width="80" align="center" />
          <el-table-column prop="name" label="作业名称" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="handleViewHomework(scope.row)">{{ scope.row.name }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" />
          <el-table-column prop="createPerson" label="创建人" align="center" />
          <el-table-column prop="subject" label="科目" align="center" />
          <el-table-column label="状态" align="center" width="150">
            <template>
              <el-tag type="info">未提交</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="300">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
              <el-button type="text" size="small" @click="handleDownload(scope.row)">下载</el-button>
              <el-button type="text" size="small" @click="handleUpload(scope.row)">上传</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="已提交作业" name="submitted">
        <el-table
          v-loading="loading"
          :data="submittedHomework"
          border
          style="width: 100%"
          empty-text="暂无已提交的作业">
          <el-table-column prop="id" label="ID" width="80" align="center" />
          <el-table-column prop="name" label="作业名称" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="handleViewHomework(scope.row)">{{ scope.row.name }}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" />
          <el-table-column prop="createPerson" label="创建人" align="center" />
          <el-table-column prop="subject" label="科目" align="center" />
          <el-table-column label="状态" align="center" width="150">
            <template slot-scope="scope">
              <el-tag :type="getGradingStatusType(scope.row.status)">
                {{ getGradingStatusText(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="分数" align="center" width="100">
            <template slot-scope="scope">
              <span v-if="getSubmissionPoint(scope.row) !== null">{{ getSubmissionPoint(scope.row) }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="300">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
              <el-button type="text" size="small" @click="handleDownload(scope.row)">下载</el-button>
              <el-button type="text" size="small" @click="handleUpload(scope.row)">上传</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <!-- 作业详情弹窗 -->
    <el-dialog title="作业详情" :visible.sync="dialogVisible" width="70%">
      <div style="display: flex;">
        <!-- 左侧：题目详情 -->
        <div style="flex: 1; border-right: 1px solid #eee; padding-right: 20px;">
          <el-table :data="homeworkDetail" border style="width: 100%">
            <el-table-column label="序号" width="80" align="center">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="content" label="题目内容" align="center" />
            <el-table-column prop="quType" label="题目类型" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.quType === 1">选择题</span>
                <span v-else-if="scope.row.quType === 2">填空题</span>
                <span v-else-if="scope.row.quType === 3">判断题</span>
                <span v-else-if="scope.row.quType === 4">简答题</span>
                <span v-else>未知类型</span>
              </template>
            </el-table-column>
            <el-table-column prop="gradeId" label="年级ID" align="center" />
          </el-table>
        </div>
        <!-- 右侧：我的作答 -->
        <div style="flex: 1; padding-left: 20px;">
          <h3>我的作答</h3>
          <div v-if="myAnswer && myAnswer.imageUrl">
            <img :src="myAnswer.imageUrl" alt="我的作答图片" style="max-width:100%;" @error="handleImageError" />
          </div>
          <div v-else>
            <span>暂无作答</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="handleDownload(currentHomework)">下 载</el-button>
      </span>
    </el-dialog>

    <!-- 上传作业弹窗 -->
    <el-dialog title="上传作业" :visible.sync="uploadDialogVisible" width="30%">
      <el-upload
        class="upload-demo"
        drag
        :action="null"
        :auto-upload="false"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        multiple
        :limit="3"
        :on-exceed="handleExceed"
        :file-list="fileList"
        :on-change="handleFileChange">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitUpload" :loading="uploading">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 批改结果弹窗 -->
    <el-dialog title="批改结果" :visible.sync="judgeResultVisible" width="70%" v-loading="uploading" element-loading-text="正在批改中，请稍候...">
      <el-table :data="judgeResults" border style="width: 100%">
        <el-table-column prop="stem" label="题目" min-width="400">
          <template slot-scope="scope">
            {{ scope.row.stem }}
          </template>
        </el-table-column>
        <el-table-column prop="judge" label="结果" width="100" align="center">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.judge === 'right' ? 'success' : (scope.row.judge === 'error' ? 'danger' : 'info')"
            >
              <template v-if="scope.row.judge === 'right'">正确</template>
              <template v-else-if="scope.row.judge === 'error'">错误</template>
              <template v-else>未判断</template>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="comment" label="评语" min-width="200">
          <template slot-scope="scope">
            {{ scope.row.comment }}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="judgeResultVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 作业批改结果弹窗 -->
    <el-dialog title="作业批改结果" :visible.sync="homeworkResultVisible" width="70%">
      <el-table :data="homeworkResults" border style="width: 100%">
        <el-table-column prop="stem" label="题目" min-width="400">
          <template slot-scope="scope">
            {{ scope.row.stem }}
          </template>
        </el-table-column>
        <el-table-column prop="judge" label="结果" width="100" align="center">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.judge === 'right' ? 'success' : (scope.row.judge === 'error' ? 'danger' : 'info')"
            >
              <template v-if="scope.row.judge === 'right'">正确</template>
              <template v-else-if="scope.row.judge === 'error'">错误</template>
              <template v-else>未判断</template>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="comment" label="评语" min-width="200">
          <template slot-scope="scope">
            {{ scope.row.comment }}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="homeworkResultVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 新增：我的作业图片弹窗 -->
    <el-dialog title="我的作业图片" :visible.sync="myImageDialogVisible" width="40%">
      <img :src="myImageUrl" alt="作业图片" style="max-width:100%;display:block;margin:auto;" v-if="myImageUrl"/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="myImageDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getToken } from '@/utils/auth'
import { parseJwt } from '@/utils/jwtUtils'
import {
  getHomeworkList,
  getStudentSubmissionsByStudentId,
  updateSubmissionStatus,
  addStudentSubmission,
  uploadFile,
  getHomeworkCorrectionResults,
  getQuestionDetail,
  addWrongQuestion,
  generateExam,
  judgeQuestion,
  getSpecificHomeworkQuestions,
  saveCorrectionResult
} from '@/api/homework'
import { getStudentBindInfo } from '@/api/user'

export default {
  name: 'homework',
  data() {
    return {
      downloaddata: {
        exam_title: '模拟考试试卷',
        student_info: {
          student_num: '',
          name: ''
        },
        question_data: [
          {
            type: '选择题',
            question: '以下哪个是正确的图标？',
            score: 5,
            options: [5, 6, 7, 8]
          },
          {
            type: '选择题',
            question: '1+1=?',
            score: 5,
            options: ['1', '2', '3', '4']
          },
          {
            type: '填空题',
            question: 'Python 中的列表用 ____ 表示。',
            score: 3
          },
          {
            type: '填空题',
            question: '2 + 3 = ____',
            score: 3
          },
          {
            type: '计算题',
            question: '计算 2 + 3 的结果。',
            score: 5
          },
          {
            type: '计算题',
            question: '计算 4 × 5 的结果。',
            score: 5
          },
          {
            type: '解答题',
            question: '简述 Python 中面向对象编程的概念。',
            score: 10
          },
          {
            type: '解答题',
            question: '解释什么是变量。',
            score: 10
          }
        ]
      },
      checkList: [],
      homeworkList: [], // 存储作业列表数据
      dialogVisible: false, // 控制弹窗显示
      homeworkDetail: [], // 存储作业详情数据
      transformedQuestions: [], // 存储转换后的题目数据
      currentHomework: null, // 当前查看的作业
      uploadDialogVisible: false, // 控制上传弹窗显示
      fileList: [], // 上传文件列表
      loading: false, // 加载状态
      selectedFiles: [], // 存储选中的文件
      totalStudents: 0, // 班级总人数
      submissions: [], // 所有提交记录
      judgeResultVisible: false, // 控制批改结果弹窗显示
      judgeResults: [], // 存储批改结果
      uploading: false, // 控制上传加载状态
      homeworkResultVisible: false, // 控制作业批改结果弹窗显示
      homeworkResults: [], // 存储作业批改结果
      myImageDialogVisible: false,
      myImageUrl: '',
      myAnswer: {}, // 存储我的作答（如图片路径等）
      finalErrorList: [], // 新增 finalErrorList
      activeTab: 'unsubmitted', // 当前激活的标签页
      questionDetails: [], // 新增 questionDetails
      selectedSubject: '', // 当前选中的科目
      subjectOptions: [
        { value: '数学', label: '数学' },
        { value: '语文', label: '语文' },
        { value: '英语', label: '英语' }
      ],
      showNoDataMessage: false,
      noDataMessage: ''
    }
  },
  computed: {
    ...mapGetters([
      'roles'
    ]),
    // 未提交的作业列表（添加科目筛选）
    unsubmittedHomework() {
      let filteredList = this.homeworkList.filter(homework => !homework.submitted)
      if (this.selectedSubject) {
        filteredList = filteredList.filter(homework => homework.subject === this.selectedSubject)
      }
      return filteredList
    },
    // 已提交的作业列表（添加科目筛选）
    submittedHomework() {
      let filteredList = this.homeworkList.filter(homework => homework.submitted)
      if (this.selectedSubject) {
        filteredList = filteredList.filter(homework => homework.subject === this.selectedSubject)
      }
      return filteredList
    }
  },
  created() {
    // 检查用户角色
    if (!this.roles.includes('student')) {
      this.$message.error('您没有权限访问此页面')
      this.$router.push('/404')
    } else {
      // 检查用户是否已选课
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      if (userInfo && userInfo.roleId === 1 && userInfo.mark === 0) {
        // 学生且未选课，显示提示信息
        this.showNoDataMessage = true
        this.noDataMessage = '暂无数据，请选课'
      } else {
        // 获取作业列表数据
        this.getHomeworkList()
      }
    }
  },
  methods: {
    test1() {
      const imageUrl = 'http://localhost:8080/api/files/question-info/e47ee971-61e6-4d01-a8bc-62a5f5d2f257.jpg'
      localStorage.setItem('lastHomeworkImage', imageUrl)
      this.$message.success('图片URL已保存')
    },

    goToCourseSelection() {
      this.$router.push({ path: '/course/selection' })
    },

    getSavedImageUrl() {
      return localStorage.getItem('lastHomeworkImage')
    },

    testdownload() {
      const requestData = {
        upload_questions: {
          exam_title: '模拟考试试卷',
          student_info: {
            student_id: '',
            name: ''
          },
          question_data: [
            {
              type: '选择题',
              question: '以下哪个是正确的图标？',
              score: 5,
              options: [5, 6, 7, 8]
            },
            {
              type: '选择题',
              question: '1+1=?',
              score: 5,
              options: ['1', '2', '3', '4']
            },
            {
              type: '填空题',
              question: 'Python 中的列表用 ____ 表示。',
              score: 3
            },
            {
              type: '填空题',
              question: '2 + 3 = ____',
              score: 3
            },
            {
              type: '计算题',
              question: '计算 2 + 3 的结果。',
              score: 5
            },
            {
              type: '计算题',
              question: '计算 4 × 5 的结果。',
              score: 5
            },
            {
              type: '解答题',
              question: '简述 Python 中面向对象编程的概念。',
              score: 10
            },
            {
              type: '解答题',
              question: '解释什么是变量。',
              score: 10
            }
          ]
        }
      }

      console.log('发送的数据:', requestData)

      generateExam(requestData)
        .then(response => {
          console.log('生成试卷响应:', response)

          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          })

          const downloadUrl = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = downloadUrl
          link.download = '试卷.docx'

          document.body.appendChild(link)
          link.click()

          setTimeout(() => {
            document.body.removeChild(link)
            window.URL.revokeObjectURL(downloadUrl)
          }, 100)

          this.$message.success('试卷生成成功，开始下载')
        })
        .catch(error => {
          console.error('生成试卷失败:', error)
          if (error.response) {
            console.error('错误响应:', error.response)
          }
          this.$message.error('生成试卷失败，请稍后重试')
        })
    },

    test() {
      updateSubmissionStatus(6, 164, '已批改')
    },

    getHomeworkList() {
      this.loading = true
      const token = getToken()
      if (!token) {
        this.$message.error('未获取到登录信息')
        this.loading = false
        return
      }
      const userInfo = parseJwt(token)
      const userId = JSON.parse(userInfo.userInfo).id

      if (!userId) {
        this.$message.error('未获取到用户ID')
        this.loading = false
        return
      }

      getHomeworkList()
        .then(response => {
          console.log('作业列表响应:', response)
          if (response.code === 1) {
            this.homeworkList = response.data
            console.log('作业列表数据:', this.homeworkList)

            getStudentSubmissionsByStudentId(userId)
              .then(submissionResponse => {
                console.log('提交状态响应:', submissionResponse)
                if (submissionResponse) {
                  this.submissions = submissionResponse;
                  this.homeworkList = this.homeworkList.map(homework => {
                    const submission = this.submissions.find(s => s.homeworkId === homework.id);
                    return {
                      ...homework,
                      submitted: submission ? submission.submitted : false,
                      status: submission ? submission.status : null,
                      point: submission ? submission.point : null
                    };
                  });
                  // 按学生班级(gradeId)过滤：仅显示与学生班级一致的作业
                  try {
                    const infoStr = window.localStorage.getItem('userInfo') || '{}'
                    const parsed = JSON.parse(infoStr)
                    const data = parsed && parsed.data ? parsed.data : {}
                    // 兼容多种字段名/结构：gradeId 或 grade_id 或 grades 数组
                    const possibleIds = []
                    if (data && (data.gradeId != null || data.grade_id != null)) {
                      possibleIds.push(String(data.gradeId != null ? data.gradeId : data.grade_id))
                    }
                    if (Array.isArray(data.grades)) {
                      data.grades.forEach(g => {
                        const gid = g && (g.id != null ? g.id : (g.gradeId != null ? g.gradeId : g.grade_id))
                        if (gid != null) possibleIds.push(String(gid))
                      })
                    }
                    const studentGradeIds = Array.from(new Set(possibleIds))
                    if (studentGradeIds.length > 0) {
                      this.homeworkList = this.homeworkList.filter(hw => {
                        const gid = hw && (hw.gradeId != null ? hw.gradeId : hw.grade_id)
                        return gid != null && studentGradeIds.includes(String(gid))
                      })
                    }
                  } catch (e) {
                    // 解析失败则不进行过滤
                  }
                  console.log('处理后的作业列表:', this.homeworkList);
                }
                this.loading = false
                this.$message.success('获取作业列表成功')
              })
              .catch(error => {
                console.error('获取提交状态失败:', error)
                this.loading = false
                this.$message.error('获取提交状态失败')
              })
          } else {
            this.loading = false
            this.$message.error(response.msg || '获取作业列表失败')
          }
        })
        .catch(error => {
          console.error('获取作业列表失败:', error)
          this.loading = false
          this.$message.error('获取作业列表失败，请稍后重试')
        })
    },

    async handleView(row) {
      this.currentHomework = row
      try {
        const response = await getSpecificHomeworkQuestions(row.id)
        if (response.code === 1) {
          // 定义题型优先级顺序
          const typeOrder = {
            1: 1, // 选择题
            2: 2, // 填空题
            3: 3, // 判断题
            4: 4 // 简答题
          }

          // 按题型排序题目
          this.homeworkDetail = response.data.sort((a, b) => {
            // 确保quType是数字类型
            const quTypeA = parseInt(a.quType) || a.quType
            const quTypeB = parseInt(b.quType) || b.quType

            const orderA = typeOrder[quTypeA] || 999
            const orderB = typeOrder[quTypeB] || 999

            if (orderA !== orderB) {
              return orderA - orderB
            }

            // 如果题型相同，按ID排序
            return a.id - b.id
          })

          const token = getToken()
          const userInfo = parseJwt(token)
          const studentId = JSON.parse(userInfo.userInfo).id

          const res = await getStudentSubmissionsByStudentId(studentId)
          console.log('获取到的提交记录:', res)

          const submission = res.find(s => s.homeworkId === row.id)
          console.log('当前作业的提交记录:', submission)

          if (submission && submission.imageUrl) {
            console.log('图片URL:', submission.imageUrl)
            let imageUrl = submission.imageUrl
            if (!imageUrl.startsWith('http')) {
              imageUrl = `http://localhost:8080${imageUrl}`
            }
            this.myAnswer = {
              ...submission,
              imageUrl: imageUrl
            }
          } else {
            this.myAnswer = {}
          }

          this.dialogVisible = true
        } else {
          this.$message.error(response.msg || '获取作业详情失败')
        }
      } catch (error) {
        console.error('获取作业详情失败:', error)
        this.$message.error('获取作业详情失败，请稍后重试')
      }
    },

    async handleDownload(row) {
      try {
        // 获取学生信息
        let studentInfo = { student_id: '', name: '' }
        try {
          const studentResponse = await getStudentBindInfo()
          if (studentResponse.code === 1 && studentResponse.data) {
            studentInfo = {
              student_id: studentResponse.data.studentNum || '',
              name: studentResponse.data.name || ''
            }
            console.log('获取到学生信息:', studentInfo)
          } else {
            console.warn('获取学生信息失败，使用默认值')
          }
        } catch (error) {
          console.warn('获取学生信息异常，使用默认值:', error)
        }

        const questionTypeMap = {
          1: '选择题',
          2: '填空题',
          3: '判断题',
          4: '简答题'
        }
        const questionData = this.homeworkDetail.map(q => ({
          type: questionTypeMap[q.quType] || '未知题型',
          question: q.content,
          score: q.score || 5
        }))

        const requestData = {
          upload_questions: {
            exam_title: this.currentHomework?.name || '作业试卷',
            student_info: studentInfo,
            question_data: questionData
          }
        }

        const response = await generateExam(requestData)
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' })
        const downloadUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = downloadUrl
        link.download = (this.currentHomework?.name || '作业') + '.docx'
        document.body.appendChild(link)
        link.click()
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(downloadUrl)
        }, 100)
        this.$message.success('试卷生成成功，开始下载')
      } catch (error) {
        this.$message.error('生成试卷失败，请稍后重试')
        console.error(error)
      }
    },

    handleUpload(row) {
      this.currentHomework = row
      getSpecificHomeworkQuestions(row.id)
        .then(response => {
          if (response.code === 1) {
            this.homeworkDetail = response.data

            const questionPromises = this.homeworkDetail.map(question =>
              getQuestionDetail(question.id)
                .then(detailResponse => {
                  if (detailResponse.code === 1) {
                    return {
                      ...question,
                      ...detailResponse.data
                    }
                  }
                  return question
                })
                .catch(error => {
                  console.error(`获取题目${question.id}详情失败:`, error)
                  return question
                })
            )

            Promise.all(questionPromises)
              .then(updatedQuestions => {
                // 保存题目详情，用于后续添加错题本
                this.questionDetails = updatedQuestions
                this.transformedQuestions = updatedQuestions.map((question, index) => ({
                  stems: `${index + 1}.${question.content}`,
                  answer: question.analysis
                }))
                this.uploadDialogVisible = true
              })
              .catch(error => {
                console.error('获取题目详情失败:', error)
                this.$message.warning('部分题目详情获取失败，显示基本信息')
                this.uploadDialogVisible = true
              })
          } else {
            this.$message.error(response.msg || '获取作业详情失败')
          }
        })
        .catch(error => {
          console.error('获取作业详情失败:', error)
          this.$message.error('获取作业详情失败，请稍后重试')
        })
    },

    async submitUpload() {
      // 检查是否已选择作业和获取到用户ID
      if (!this.currentHomework || !this.currentHomework.id) {
        this.$message.error('未选择作业或作业ID无效')
        return
      }

      const token = getToken()
      if (!token) {
        this.$message.error('未获取到登录信息')
        return
      }
      const userInfo = parseJwt(token)
      const userId = JSON.parse(userInfo.userInfo).id

      if (!userId) {
        this.$message.error('未获取到用户ID')
        return
      }

      if (this.fileList.length === 0) {
        this.$message.error('请选择要上传的文件')
        return
      }

      // 设置上传状态，隐藏上传弹窗
      this.uploading = true;
      this.uploadDialogVisible = false;

      // 显示处理中的加载消息
      let loadingMessage = this.$message({
        message: `正在处理 ${this.fileList.length} 张图片，请稍候...`,
        type: 'info',
        duration: 0,
        showClose: true
      })

      const allCorrectionResults = []; // 存储所有图片的批改结果

      try {
        // 遍历用户上传的每一张图片
        for (let i = 0; i < this.fileList.length; i++) {
          const file = this.fileList[i];

          // 显示当前正在处理的图片信息
          this.$message({
              message: `正在上传并批改第 ${i + 1} 张图片...`,
              type: 'info',
              duration: 1500 // 短暂显示
          });

          // 1. 上传当前的图片到 MinIO
          const uploadFormData = new FormData();
          uploadFormData.append('file', file.raw);
          const minioResponse = await uploadFile(uploadFormData);

          // 检查上传结果
          if (minioResponse.code !== 1) {
            console.error(`图片 ${i + 1} 上传失败:`, minioResponse.msg || '未知错误');
            this.$message.error(`图片 ${i + 1} 上传失败`);
            continue; // 当前图片处理失败，跳过后续步骤，继续处理下一张
          }

          const imageUrl = `http://localhost:8080/api/files${minioResponse.msg}`;

          // 2. 为当前的图片创建一条新的学生提交记录
          const submissionResponse = await addStudentSubmission({
            homeworkId: this.currentHomework.id,
            studentId: userId,
            submitted: true,
            imageUrl: imageUrl // 使用当前图片的 URL
          });

          if (!submissionResponse || typeof submissionResponse.id === 'undefined') {
             console.error(`图片 ${i + 1} 提交记录创建失败:`, submissionResponse ? (submissionResponse.msg || '后端返回数据结构异常') : '后端未返回数据');
             this.$message.error(`图片 ${i + 1} 提交记录创建失败`);
             continue; // 当前图片处理失败，跳过后续步骤，继续处理下一张
          }

          // 3. 调用 judgeQuestion 接口对当前的图片进行批改
          const recognitionFormData = new FormData();
          recognitionFormData.append('image', file.raw);
          // 使用之前获取到的转换后的题目列表
          recognitionFormData.append('questions', JSON.stringify({
            question_list: this.transformedQuestions
          }))

          const recognitionResponse = await judgeQuestion(recognitionFormData);

          // 检查批改结果
          if (recognitionResponse && Array.isArray(recognitionResponse.result) && recognitionResponse.result.length > 0) {
            // 将当前图片的批改结果添加到总结果列表中
             recognitionResponse.result.forEach(item => {
                 allCorrectionResults.push(item);
             });

            // 4. 保存当前图片的批改结果
             const savePromises = recognitionResponse.result.map(result => {
               const correctResult = {
                 homeworkId: this.currentHomework.id,
                 studentId: userId,
                 stem: result.stem,
                 judge: result.judge || '未批改',
                 comment: result.comment || ''
               };
               return saveCorrectionResult(correctResult);
             });
             await Promise.all(savePromises);
          } else {
             console.warn(`图片 ${i + 1} 未返回有效的批改结果`);
             this.$message.warning(`图片 ${i + 1} 未返回有效的批改结果`);
          }
        } // 遍历图片结束

        // 所有图片处理完成后，关闭加载消息
        // loadingMessage.close(); // 移除这里的关闭，统一放到 finally

        // 5. 更新提交状态 (如果至少处理了一张图片)
         if (this.fileList.length > 0) {
             await updateSubmissionStatus(this.currentHomework.id, userId, '已批改');
         }

        this.$message.success('所有图片处理完成！');

        // 6. 显示所有图片的合并批改结果
        this.homeworkResults = allCorrectionResults;
        this.homeworkResultVisible = true;

        // 7. 刷新作业列表以更新状态显示
        this.getHomeworkList();

        // 8. （可选）根据所有结果添加错题到错题本
         if (allCorrectionResults.length > 0 && this.questionDetails) {
            const wrongQuestions = allCorrectionResults.filter(result => result.judge === 'error');
             const addedWrongQuestions = new Set();

             if (wrongQuestions.length > 0) {
                 const addToWrongBookPromises = wrongQuestions.map(question => {
                   const originalQuestion = this.questionDetails.find(q =>
                     question.stem.includes(q.content)
                   );

                   if (!originalQuestion) {
                     console.error('未找到对应的题目详情，无法添加到错题本:', question.stem);
                     return Promise.resolve();
                   }

                   if (addedWrongQuestions.has(originalQuestion.id)) {
                       return Promise.resolve();
                   }
                   addedWrongQuestions.add(originalQuestion.id);

                  return addWrongQuestion({
                    student_id: userId,
                     content: question.stem,
                     analysis: question.comment || originalQuestion.analysis || '',
                     knowledge: originalQuestion.knowledge || '',
                     chapter: originalQuestion.chapter || '',
                     suboptions: originalQuestion.suboptions || '数学',
                     answer: originalQuestion.answer || ''
                   });
                 });
                 await Promise.all(addToWrongBookPromises);
                 if (addedWrongQuestions.size > 0) {
                     this.$message.success(`已将 ${addedWrongQuestions.size} 道错题加入错题本`);
                 }
             }
         }
      } catch (error) {
        // 捕获处理图片过程中的任何未预期错误
        console.error('处理图片过程中发生错误:', error);
        this.$message.error('处理图片过程中发生错误，请稍后重试');
      } finally {
        // 最终都会执行的操作：取消上传状态，清空文件列表，并关闭 loadingMessage
        if (loadingMessage) loadingMessage.close();
        this.uploading = false;
        this.fileList = [];
      }
    },

    handleViewHomework(row) {
      console.log('开始获取作业批改结果，作业ID:', row.id)
      const token = getToken()
      const userInfo = parseJwt(token)
      const userId = JSON.parse(userInfo.userInfo).id

      getHomeworkCorrectionResults(row.id, userId)
        .then(response => {
          console.log('获取到的原始响应:', response)
          if (Array.isArray(response)) {
            console.log('批改结果数据:', response)
            this.homeworkResults = response
            this.homeworkResultVisible = true
            console.log('设置后的 homeworkResults:', this.homeworkResults)
          } else {
            console.log('未找到批改结果数据')
            this.$message.error('未获取到批改结果')
          }
        })
        .catch(error => {
          console.error('获取批改结果失败:', error)
          this.$message.error('获取批改结果失败，请稍后重试')
        })
    },

    handleMy(row) {
      const token = getToken()
      if (!token) {
        this.$message.error('未获取到登录信息')
        return
      }
      const userInfo = parseJwt(token)
      const studentId = JSON.parse(userInfo.userInfo).id
      if (!studentId) {
        this.$message.error('未获取到用户ID')
        return
      }
      getStudentSubmissionsByStudentId(studentId)
        .then(res => {
          if (res && Array.isArray(res)) {
            const submission = res.find(s => s.homeworkId === row.id)
            if (submission && submission.imageUrl) {
              let url = submission.imageUrl
              if (/^(blob:|https?:\/\/|\/)/.test(url)) {
                if (!/^https?:\/\//.test(url) && !/^blob:/.test(url)) {
                  url = 'http://localhost:8080' + url
                }
                this.myImageUrl = url
                this.myImageDialogVisible = true
              } else {
                this.$message.info('图片地址无效')
              }
            } else {
              this.$message.info('未上传图片')
            }
          } else {
            this.$message.info('未上传图片')
          }
        })
        .catch(() => {
          this.$message.error('获取图片信息失败')
        })
    },

    async addToWrongBook() {
      if (!this.finalErrorList || this.finalErrorList.length === 0) {
        this.$message.warning('没有可加入错题本的题目')
        return
      }
      try {
        for (const item of this.finalErrorList) {
          await addWrongQuestion({
            student_id: item.studentId,
            content: item.stem,
            analysis: item.comment || '',
            knowledge: item.knowledge || '',
            chapter: item.chapter || '',
            suboptions: '数学',
            answer: item.answer || ''
          })
        }
        this.$message.success('已加入错题本')
      } catch (e) {
        this.$message.error('加入错题本失败')
        console.error(e)
      }
    },

    getGradingStatusType(status) {
      if (!status) return 'info'
      return status === '已批改' ? 'success' : 'warning'
    },
    getGradingStatusText(status) {
      if (!status) return '未提交'
      return status === '已批改' ? '已批改' : '未批改'
    },
    goToUpload() {
      this.$router.push({ name: 'UploadComponent' })
    },
    goToPrint() {
      this.$router.push({ name: 'PrintComponent' })
    },
    // 计算提交率
    getSubmissionRate(homeworkId) {
      if (this.totalStudents === 0) return '0%'

      const submittedCount = this.submissions.filter(
        submission => submission.homeworkId === homeworkId && submission.submitted
      ).length

      const rate = (submittedCount / this.totalStudents) * 100
      return rate.toFixed(1) + '%'
    },
    // 解码Unicode字符串
    decodeUnicode(str) {
      if (!str) return ''
      return decodeURIComponent(escape(str))
    },
    handleImageError(event) {
      console.error('图片加载失败:', event)
      this.$message.error('图片加载失败，请检查网络连接')
    },
    handleFileChange(file, fileList) {
      this.fileList = fileList
    },

    handlePreview(file) {
      console.log('预览文件:', file)
    },

    handleRemove(file, fileList) {
      console.log('移除文件:', file, fileList)
    },

    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },

    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },

    getSubmissionPoint(homework) {
      return homework.point;
    },
    // 处理科目变化
    handleSubjectChange(value) {
      this.selectedSubject = value
      // 可以在这里添加其他处理逻辑，比如重新获取数据等
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
}
.el-tabs {
  margin-top: 20px;
}

.empty-homework-card {
  margin-bottom: 30px;
  text-align: center;
}

.homework-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.homework-header span {
  font-size: 18px;
  font-weight: bold;
  color: #409EFF;
}

.empty-content {
  padding: 40px 20px;
}

.empty-icon {
  font-size: 80px;
  color: #c0c4cc;
  margin-bottom: 20px;
}

.empty-text h3 {
  color: #606266;
  margin-bottom: 10px;
}

.empty-text p {
  color: #909399;
  margin-bottom: 30px;
}

.empty-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
}
</style>
